<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="projectTitle" [hidden]="inviteFilterValue === 'uninvite'">Enviar convite</h5>
    <h5 class="modal-title" id="projectTitle" [hidden]="inviteFilterValue === 'invite'">Desfazer convite</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row" [hidden]="!people.length">
      <div style="margin-left: 10px;" class="d-flex justify-content-between">
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="invite" name="radioInvite" class="custom-control-input" [value]="'invite'"
            [(ngModel)]="inviteFilterValue"
            (change)="handleRadio()">
          <label class="custom-control-label" for="invite">Convidar</label>
        </div>
        <div class="custom-control custom-radio custom-control-inline">
          <input type="radio" id="uninvite" name="radioInvite" class="custom-control-input" [value]="'uninvite'"
            [(ngModel)]="inviteFilterValue"
            (change)="handleRadio()">
          <label class="custom-control-label" for="uninvite">Desconvidar</label>
        </div>
      </div>
    </div>

    <div [hidden]="inviteFilterValue === 'invite'" style="margin-top: 10px;">
      <div class="row">
        <div class="col">
          <div class="breadcrumb">
            <h3>Selecione uma ou mais opções para desconvidar</h3>
          </div>
        </div>
        <div class="col-md-12" *ngFor="let author of people; let i = index;">
          <div class="form-check">
            <input
              class="form-check-input"
              [value]="author.id"
              [(ngModel)]="author.checked"
              name="authors"
              type="checkbox"
              id="authorCheck{{i}}">
            <label class="form-check-label" for="authorCheck{{i}}">
              {{ author.role }} - {{ author.name }}
            </label>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-link" (click)="activeModal.dismiss()">Voltar</button>
        <button type="button" (click)="onUninvite()" [attr.data-loader]="!submittedUninvite" btnloader class="btn btn-primary">
          Desconvidar
        </button>
      </div>
    </div>

    <div [formGroup]="invitationForm" [hidden]="inviteFilterValue === 'uninvite'" style="margin-top: 20px;">
      <div class="form-group">
        <div class="input-group">
          <div class="input-group-prepend">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">{{ role }}</button>
            <div class="dropdown-menu">
              <button type="button" class="dropdown-item" (click)="selectRole('author')">Convidar autor(a)</button>
              <div role="separator" class="dropdown-divider"></div>
              <button type="button" class="dropdown-item" (click)="selectRole('advisor')">Convidar
                orientador(a)</button>
              <div role="separator" class="dropdown-divider"></div>
              <button type="button" class="dropdown-item" (click)="selectRole('co-supervisor')">Convidar
                coorientador(a)</button>
              <div role="separator" class="dropdown-divider"></div>
              <button type="button" class="dropdown-item" (click)="selectRole('mentor')">Convidar mentor(a)</button>
            </div>
          </div>
          <ng-select
            #emailFieldRef
            class="form-control"
            [items]="guest$ | async"
            bindLabel="email"
            placeholder="Digite o e-mail do convidado"
            [hideSelected]="true"
            [trackByFn]="trackByFn"
            [minTermLength]="20"
            [loading]="guestLoading"
            typeToSearchText="E-mail"
            [typeahead]="guestInput$"
            [(ngModel)]="selectedGuest"
            formControlName="email"
            [ngModelOptions]="{standalone: true}"
          >
          </ng-select>
          <small class="invalid-feedback" *ngIf="submitted && invitationForm.get('email').hasError('required')">
            O email não foi informado
          </small>
        </div>
      </div>

      <div class="form-group" [hidden]="nameIsNotRequired">
        <label for="title">Nome *</label>
        <input type="text" formControlName="name" [(ngModel)]="invitation.name"
          [ngModelOptions]="{standalone: true}" class="form-control" id="name"
          [ngClass]="{ 'is-invalid': submitted && invitationForm.get('name').hasError('required') }" placeholder="Nome *">
        <small class="invalid-feedback" *ngIf="submitted && invitationForm.get('name').hasError('required')">
          O nome não foi informado
        </small>
      </div>

      <div class="row">
        <div *ngIf="showBlindSelection" class="form-group col-3">
          <div class="custom-control custom-switch">
            <input type="checkbox" formControlName="blind_selection" [(ngModel)]="invitation.blind_selection"
              [ngModelOptions]="{standalone: true}" class="custom-control-input" id="blind_selection">
            <label class="custom-control-label" for="blind_selection">seleção cega</label>
          </div>
        </div>

        <!-- <div class="form-group col-8" *ngIf="emailAlreadyExists">
          <div class="custom-control custom-switch">
            <input type="checkbox" formControlName="platform_invite" [(ngModel)]="invitation.platform_invite"
              [ngModelOptions]="{standalone: true}" class="custom-control-input" id="platform_invite">
            <label class="custom-control-label" for="platform_invite">enviar convite via plataforma</label>
          </div>
        </div> -->
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-link" (click)="activeModal.dismiss()">Voltar</button>
        <button type="button" (click)="save()" [attr.data-loader]="!submitted" btnloader class="btn btn-primary">
          Convidar
        </button>
      </div>
    </div>
  </div>
</div>
